import { useCallback, useEffect, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import { useSilver } from "@/context/SilverContext";
import { DefineView } from "@/components/silver/tool/DefineView";
import { CompilationOverlay } from "@/components/silver/tool/CompilationOverlay";
import ResultsDashboard from "@/components/silver/results/ResultsDashboard";
import { CampaignStage } from "@/components/silver/builder/CampaignStage";

export default function AudienceTool() {
  const { phase, setPhase } = useSilver();
  const first = useRef(true);

  const handleCompiled = useCallback(() => setPhase("results"), [setPhase]);

  // Each stage opens at the top of the workspace.
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (phase !== "analysing") window.scrollTo({ top: 0, behavior: "auto" });
  }, [phase]);

  return (
    <section id="build" className="relative isolate scroll-mt-4" data-testid="audience-tool-section">
      <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true">
        <div className="absolute inset-0 bg-[#0C2010]/70" style={{ maskImage: "linear-gradient(to bottom, transparent, black 220px, black calc(100% - 220px), transparent)", WebkitMaskImage: "linear-gradient(to bottom, transparent, black 220px, black calc(100% - 220px), transparent)" }} />
        <div className="absolute inset-0 opacity-60" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)", backgroundSize: "28px 28px", maskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)", WebkitMaskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)" }} />
      </div>

      <div className="mx-auto min-h-[70vh] max-w-7xl px-5 pb-28 pt-20 sm:px-8 lg:pb-36 lg:pt-24">
        <AnimatePresence mode="wait">
          {phase === "campaign" ? <CampaignStage key="campaign" /> : phase === "results" ? <ResultsDashboard key="results" /> : <DefineView key="define" />}
        </AnimatePresence>
      </div>

      <AnimatePresence>{phase === "analysing" && <CompilationOverlay key="compiler" onComplete={handleCompiled} />}</AnimatePresence>
    </section>
  );
}
